export default "__VITE_ASSET__Bc8BWoca__"